import { Col, Row } from '@advanza/grid'
import { Button, Divider, LoadingDots, PreIcon } from '@advanza/ui'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import BaseModal, {
    BaseModalFooter,
    BaseModalHeader,
    BaseModalMainContent,
} from '@trustoo/components/modal/BaseModal'
import { reclaimMatch } from 'actions/matches'
import { reclaimPhoneClick } from 'actions/phoneClicks'
import { reclaimWebsiteClick } from 'actions/websiteClicks'
import DatePicker from 'components/DatePicker'
import {
    LEAD_TYPE_MATCHES,
    LEAD_TYPE_PHONE_CLICKS,
    LEAD_TYPE_WEBSITE_CLICKS,
    LeadType,
} from 'components/matches/ManualReclaimButton'
import { useAppDispatch } from 'hooks/hooks'
import { useState } from 'react'

function useReclaimFunc(leadType: LeadType, id: number) {
    const dispatch = useAppDispatch()
    return (date: string | false) => {
        switch (leadType) {
            case LEAD_TYPE_MATCHES:
                return dispatch(reclaimMatch(id, date))
            case LEAD_TYPE_PHONE_CLICKS:
                return dispatch(reclaimPhoneClick(id, date))
            case LEAD_TYPE_WEBSITE_CLICKS:
                return dispatch(reclaimWebsiteClick(id, date))
        }
    }
}

interface Props {
    lead: any
    leadType: LeadType
    leadId: number
}

const ManualReclaimButton = NiceModal.create(({ lead, leadType, leadId }: Props) => {
    const modal = useModal()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)
    const [date, setDate] = useState<string | false>(false)
    const [showCustomDate, setShowCustomDate] = useState(false)
    const reclaimFunc = useReclaimFunc(leadType, leadId)
    const onReclaim = () => {
        setLoading(true)
        reclaimFunc(date).then(
            () => {
                setLoading(false)
                modal.hide()
            },
            ({ error }) => {
                setLoading(false)
                setError(error)
            },
        )
    }
    const headerContent = (() => {
        if (loading) {
            return (
                <>
                    Reclaiming <LoadingDots />
                </>
            )
        }
        if (error) {
            return 'Error'
        }
        return 'Reclaim lead'
    })()
    const footerContent = (() => {
        if (!error && lead.reclaimId && !lead.reclaimDenied) {
            return ''
        }
        if (error) {
            return error
        }
        return (
            <Button onClick={onReclaim}>
                {loading ? <LoadingDots color="#dadada" /> : 'Confirm reclaim'}
            </Button>
        )
    })()
    return (
        <BaseModal>
            <BaseModalHeader>
                <h3>{headerContent}</h3>
            </BaseModalHeader>
            <BaseModalMainContent>
                {lead.reclaimDenied && (
                    <b style={{ color: 'red' }}>
                        This reclaim is denied. Are you sure you want to approve it?
                    </b>
                )}
                {!lead.reclaimDenied && lead.reclaimId && (
                    <b style={{ color: 'orange' }}>This match has an open reclaim.</b>
                )}
                {lead.advanzaId && (
                    <a
                        style={{
                            color: 'red',
                            fontWeight: 'bold',
                            textDecoration: 'underline',
                        }}
                        href={`https://leads.advanza.nl/Company/wrapper?company_id=${lead.advanzaId}`}>
                        {' '}
                        Warning! This company is also present on Advanza.
                    </a>
                )}
                <Divider m />
                {showCustomDate ? (
                    <Row>
                        <Col x>
                            <DatePicker
                                value={date || null}
                                onChange={(e) => setDate(e.target.value)}
                                opened
                            />
                        </Col>
                    </Row>
                ) : (
                    <div>
                        <Button name="text" onClick={() => setShowCustomDate(true)}>
                            <PreIcon icon="keyboard_arrow_down">set custom date</PreIcon>
                        </Button>
                        <Divider />
                    </div>
                )}
            </BaseModalMainContent>
            <BaseModalFooter>
                <Row middle="xs">
                    <Col x>{footerContent}</Col>
                    <Col x>
                        <button onClick={() => modal.hide()}>cancel</button>
                    </Col>
                </Row>
            </BaseModalFooter>
        </BaseModal>
    )
})

export default ManualReclaimButton
